<app-modal-filler-atom
  (click)="close()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed inset-x-0 shadow overflow-y-auto mdMax:bottom-0 mdMax:max-h-85-screen mdMax:max-w-screen-sm mdMax:mx-auto md:flex md:justify-center md:items-center md:w-full md:h-full md:top-0 md:left-0"
  [style.z-index]="(index$ | async) + 50"
>
  <app-modal-filler-atom
    *ngIf="isDesktop$ | async"
    [withBackdrop]="false"
    (click)="close()"
    [index]="index$ | async"
  ></app-modal-filler-atom>
  <div
    class="bg-white py-5 md:py-7 rounded-t-3xl md:rounded-3xl md:max-w-lg flex flex-col"
    [style.z-index]="(index$ | async) + 50"
  >
    <div class="flex justify-between items-center px-5 md:px-7 pb-5">
      <h1
        class="text-neutral-800 font-brand font-bold text-28px"
        [translate]="modalHeading"
      ></h1>
    </div>

    <ng-container *ngIf="!this.isLoading && !this.accountExists">
      <div class="md:px-2">
        <app-pongo-marketplace-rewards-list-block> </app-pongo-marketplace-rewards-list-block>
      </div>

      <form [formGroup]="form">
        <div
          *ngIf="!phoneNumberDefinedByUser"
          class="pb-6 px-5 md:px-7"
        >
          <label
            for="phone"
            class="block mb-1 text-sm leading-5 font-base font-normal text-neutral-600"
            translate="signup.phone"
          ></label>
          <label
            for="phone"
            class="block mb-2 text-xs font-base font-normal text-neutral-500"
          >
            {{ 'pongo.help-phone-format' | translate }}
          </label>
          <input
            id="phone"
            type="tel"
            formControlName="phone"
            class="flex w-full py-8xs px-5 bg-neutral-50 text-base font-base font-normal leading-5 border border-solid border-neutral-300"
            [class.border-error-700]="
              phoneErrorMessage ||
              (form.controls?.phone?.invalid &&
                (form.controls?.phone?.dirty || form.controls?.phone?.touched))
            "
          />
          <ng-container
            *ngIf="
              form.controls?.phone?.invalid &&
              (form.controls?.phone?.dirty || form.controls?.phone?.touched)
            "
          >
            <span
              class="text-xs font-base font-normal text-error-700"
              *ngIf="form.controls?.phone?.errors"
              translate="signup.invalid-phone"
            ></span>
          </ng-container>
          <ng-container *ngIf="phoneErrorMessage">
            <span
              class="text-xs font-base font-normal text-error-700"
              [translate]="phoneErrorMessage"
            ></span>
          </ng-container>
        </div>
        <div class="flex mb-7 pb-2 px-5 md:px-7">
          <input
            type="checkbox"
            [id]="'pongoOptin'"
            [name]=""
            class="form-checkbox mr-3.5 h-5 w-5 border text-primary-600"
            formControlName="optin"
          />
          <label
            [for]="'pongoOptin'"
            class="text-sm font-base font-normal mr-4"
            >{{ 'pongo.optin-checkbox-label' | translate }}</label
          >
        </div>
      </form>

      <div class="px-5 md:px-7 grid grid-cols-2 gap-4">
        <app-button-atom
          [type]="'light'"
          [label]="'pongo.continue-without-loyalty-button' | translate"
          [size]="'L'"
          (click)="close()"
          [full]="true"
        ></app-button-atom>
        <app-button-atom
          [type]="'primary'"
          [label]="'pongo.continue-with-loyalty-button' | translate"
          [size]="'L'"
          (click)="attachCustomer()"
          [full]="true"
          [iconUrl]="isValidating ? 'assets/images/spinner.svg' : undefined"
          [disabled]="isValidating"
        ></app-button-atom>
      </div>
    </ng-container>

    <ng-container *ngIf="!this.isLoading && this.accountExists">
      <div class="pb-7 px-5">
        <p class="text-neutral-800 font-base text-base pb-3">
          {{ 'pongo.already-member-information' | translate }}
        </p>
      </div>
      <div class="pb-3 px-5">
        <app-button-atom
          [type]="'light'"
          [label]="'pongo.already-member-close-button' | translate"
          [size]="'L'"
          (click)="close()"
        ></app-button-atom>
      </div>
    </ng-container>

    <ng-container *ngIf="this.isLoading">
      <div class="flex flex-row items-center justify-center h-48 w-full">
        <img
          src="assets/images/spinner.svg"
          class="pr-4"
        />
      </div>
    </ng-container>
  </div>
</div>
